import request from '@/utils/request';
//撤回校审核或者学段审核
export const recallCell = data => {
    return request({
        url: '/api/audit/backNode',
        method: 'post',
        data
    });
};
// 批量区级审核
export const batchSchoolAudit = data => {
    return request({
        url: '/api/audit/batchSchoolAudit',
        method: 'post',
        data
    });
};

// 课题申报

//根据登录人的区级获取课题项目列表
export const getEduProjectLsit= () => {
    return request({
        url: '/api/eduProject/list',
        method: 'get',
    });
};
//添加或编辑课题项目表
export const addOrEditProject = data => {
    return request({
        url: '/api/eduProject/saveOrUpdate',
        method: 'post',
        data
    });
};
// 删除项目
export const delProject = id => {
    return request({
        url: `/api/eduProject/del/${id}`,
        method: 'get',
    });
};


//根据当前登录人的区域id查看有多少单位
export const getUnitNumberById = () => {
    return request({
        url: '/api/eduProject/unitNumber',
        method: 'get',
    });
};

//添加课题申报
export const addEduSubjectDeclare = params => {
    return request({
        url: '/api/eduSubjectDeclare/add',
        method: 'post',
        data:params
    });
};


// 获取课题申报列表
export const getTopicsDeclarationList = data => {
    return request({
        url: '/api/eduSubjectDeclare/list',
        method: 'post',
        data
    });
};

// 添加或修改课题申报
export const addOrEditTopicsDeclaration = data => {
    return request({
        url: '/api/eduSubjectDeclare/saveOrUpdate',
        method: 'post',
        data
    });
};

//删除课题申报
export const delTopicsDeclaration = id => {
    return request({
        url: '/eduSubjectDeclare/delete/'+id,
        method: 'post',
    });
};


// 根据课题申报ID查询课题申报详情——回显
export const getTopicsDeclarationById = id => {
    return request({
        url: '/api/eduSubjectDeclare/getInfo/'+id,
        method: 'get'
    });
};


//查询有多个单位的区域
export const getHasUnitsArea = () => {
    return request({
        url: '/api/eduProject/getUnitList',
        method: 'get',
    });
};

// 根据项目id获取课题类别列表
export const getTopicCateById = (id) => {
    return request({
        url: `/api/eduSubjectDeclare/getProjectTypeByProjectId/${id}`,
        method: 'get',
    });
};

// 申报汇总统计-申报汇总数据
export const getDeclarationSum = (data) => {
    return request({
        url: `/api/count/countSummaryList`,
        method: 'post',
				data
    });
};

// 申报汇总统计-申报明细数据
export const getDeclarationDetail = (data) => {
    return request({
        url: `/api/count/countDeclareInfo`,
        method: 'post',
				data
    });
};

// 申报汇总统计-申报统计柱状图列表
export const getBarData = (id) => {
    return request({
        url: `/api/count/countDeclareColumnarList/${id}`,
        method: 'get',
    });
};

// 申报汇总统计-申报统计饼图列表
export const getPieData = (id) => {
    return request({
        url: `/api/count/countDeclarePieInfo/${id}`,
        method: 'get',
    });
};

// 申报汇总统计-申报统计文字描述信息
export const getFontData = (id) => {
    return request({
        url: `/api/count/countDeclareTextInfo/${id}`,
        method: 'get',
    });
};
// 根据用户id判断该用户是否有未完成的课题
export const isHasNotFinishTopic = (id) => {
    return request({
        url: `/api/eduSubjectDeclare/getUserIdBySubjectDeclare/${id}`,
        method: 'post',
    });
};

// 课题申报按钮权限控制
export const topicDeclareBtnRightControl = (projectId) => {
    return request({
        url: `/api/eduSubjectDeclare/declareButtonPermissions/${projectId}`,
        method: 'get',
    });
};
